import React, { useCallback, useEffect } from 'react';
import Cookie from 'js-cookie';
import { req, useApiGet, useApiLoading } from 'react-reqq-lite';
import { showDrawer } from 'partial/components/Modal';
import { storage } from 'helper';
import { getUserTypeFromToken } from './transformers';
import OverrideModal from './modals/OverrideModal';
import * as c from './constants';
import {
  changePassword,
  forgotPassword,
  login,
  resetPassword,
} from './actions';

export const useAuth = () => {
  const auth = useApiGet(c.AUTHENTICATION, {});
  useEffect(() => {
    const token = Cookie.get('_token');
    req.set(c.AUTHENTICATION, {
      isAuthenticated: !!token,
      userType: getUserTypeFromToken(token),
    });
  }, []);
  return [typeof auth.isAuthenticated === 'boolean', auth.isAuthenticated];
};

export const useProfile = () => {
  const profile = useApiGet(c.PROFILE, {});
  useEffect(() => {
    const self = storage.get('_profile');
    req.set(c.PROFILE, self);
  }, []);
  return [profile];
};

export const useLogin = () => {
  const isLoading = useApiLoading(c.LOGIN, 'post');
  const submit = useCallback((payload) => {
    login(payload);
  }, []);
  return [isLoading, submit];
};

export const withOverride = (func) => {
  showDrawer({
    title: 'Override',
    className: 'modal-sm',
    content: (close) => <OverrideModal onSubmit={func} onClose={close} />,
  });
};

export const useForgotPassword = () => {
  const isLoading = useApiLoading(c.FORGOT_PASSWORD, 'post');
  const submit = useCallback((payload, onSuccess) => {
    forgotPassword(payload, onSuccess);
  }, []);
  return [isLoading, submit];
};

export const useResetPassword = () => {
  const isLoading = useApiLoading(c.RESET_PASSWORD, 'post');
  const submit = useCallback((payload, onSuccess) => {
    resetPassword(payload, onSuccess);
  }, []);
  return [isLoading, submit];
};

export const useChangePassword = () => {
  const isLoading = useApiLoading(c.CHANGE_PASSWORD, 'put');
  const submit = useCallback((payload, onSuccess) => {
    changePassword(payload, onSuccess);
  }, []);
  return [isLoading, submit];
};
